<div class="main-container">
  <mat-toolbar color="#FFFFFF" class="topbar telative" style="background-color: #FFFFFF; position: relative;">
    <div class="navbar-header" style="text-align: left;">
      <a routerLink="/dashboard" class="navbar-brand" style="cursor: pointer;" (click)="clearSessionStorage()">
        <b>
          <img src="assets/images/logos/PrimeRx-P3-Logo.jpg"
               width="75%"
               alt="homepage"
               class="light-logo">
        </b>
        <span fxShow="false" fxShow.gt-xs></span>
      </a>
    </div>

    <label  class="environment-chip-container" [ngStyle]="{ 'background-color': envColor , 'color': envTextColor }">
      {{ environment }}
    </label>

    <div fxFlex fxLayout="row" fxLayoutAlign="end center" fxFlex="100">


      <div class="item" style="padding: 20px;"><label style="font-size: 17px; font-weight: bold; text-align: left; color: #0C7BB8;">NPI No. - {{userAccessData.NPINo}}</label></div>
      <div class="item" style="padding: 20px;"><label style="font-size: 17px; font-weight: bold; text-align: left; color: #0C7BB8;">{{userAccessData.storeName}}</label></div>
    </div>
    <span fxFlex></span>
    <app-header></app-header>
  </mat-toolbar>

  <mat-drawer-container class="example-container mat-typography" autosize>
    <mat-drawer #drawer mode="side" disableClose="true" opened="true" style="background-color: #1B2033;" [ngStyle]="{'width.px': isExpanded ? 50 : 280}">
      <div class="sidebar-container" style="height: calc(100% - 100px); overflow-y: auto; scrollbar-width: thin;">

      <app-sidebar [sidenavOpened]="isExpanded"></app-sidebar>
      </div>
      <!-- Sidebar Footer -->
      <div class="bottom-items" style="height: 100px; position: absolute; bottom: 0; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: #1B2033;">
        <div class="bottom-item">
          <button mat-icon-button (click)="toggleSidebar()" value="sidebarclosed" color="#F59120" [matTooltip]="getTooltipText()" style="padding-left: 10px;color: #F59120;">
        <mat-icon>{{ isExpanded ? 'chevron_right' : 'chevron_left' }}</mat-icon>
          </button>
        </div>
        <div *ngIf="!isExpanded" class="bottom-item" style="text-align: center;">
          <mat-label style="color: #ADADAD;font-size:x-small;">© 2025 Micro Merchant Systems, Inc. <br> P3v18.1 All rights reserved.</mat-label>
        </div>
      </div>
    </mat-drawer>
    <mat-drawer-content class="page-wrapper">
      <div>
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>


</div>
